import { render, staticRenderFns } from "./detailJobOrder.vue?vue&type=template&id=4cb1fdc8"
import script from "./detailJobOrder.vue?vue&type=script&lang=js"
export * from "./detailJobOrder.vue?vue&type=script&lang=js"
import style0 from "./detailJobOrder.vue?vue&type=style&index=0&id=4cb1fdc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports